module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Button Background</span></div>\r\n</div>\r\n<div class=\"row\" style=\"padding-top:5px;\">\r\n	\r\n	<div class=\"col-md-6\">\r\n		<input id=\"buttonBackgroundColorPicker\" name=\"buttonBackgroundColorPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( buttonBackgroundColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n	    <input id=\"buttonBackgroundColor\" name=\"buttonBackgroundColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( buttonBackgroundColor ))
    ; __append("\" />\r\n    </div>\r\n\r\n    <div class=\"col-md-6\">\r\n		<input id=\"buttonBackgroundGradientColorPicker\" name=\"buttonBackgroundGradientColorPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( buttonBackgroundGradientColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n	    <input id=\"buttonBackgroundGradientColor\" name=\"buttonBackgroundGradientColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( buttonBackgroundGradientColor ))
    ; __append("\" />\r\n	</div>     \r\n\r\n</div>")
  }
  return __output;

}